var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3996 8.5103C15.7487 8.51425 14.1382 7.99938 12.7957 7.03842V13.7404C12.7953 14.9817 12.4159 16.1933 11.7083 17.2131C11.0007 18.2329 9.99856 19.0124 8.83597 19.4474C7.67337 19.8823 6.40571 19.9519 5.20247 19.647C3.99924 19.342 2.91778 18.6769 2.10272 17.7407C1.28766 16.8046 0.777834 15.6418 0.641419 14.4081C0.505005 13.1743 0.748503 11.9283 1.33935 10.8367C1.93021 9.74502 2.84025 8.85978 3.94779 8.29931C5.05534 7.73884 6.3076 7.52985 7.53712 7.7003V11.0712C6.97449 10.8942 6.37032 10.8995 5.8109 11.0864C5.25148 11.2733 4.76541 11.6321 4.4221 12.1117C4.0788 12.5913 3.89582 13.1672 3.8993 13.757C3.90277 14.3468 4.09252 14.9204 4.44145 15.3959C4.79038 15.8714 5.28064 16.2246 5.84223 16.4048C6.40381 16.5851 7.008 16.5833 7.56851 16.3997C8.12902 16.2161 8.61718 15.8601 8.96329 15.3825C9.30941 14.905 9.49576 14.3302 9.49575 13.7404V0.638672H12.7957C12.7935 0.917349 12.8168 1.19565 12.8655 1.47005C12.9802 2.0826 13.2186 2.66532 13.5662 3.18257C13.9138 3.69982 14.3633 4.14072 14.8871 4.4783C15.6324 4.97108 16.5062 5.23373 17.3996 5.23355V8.5103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktokIcon.eca2d52462dfa131210ff6623a529e73.svg";
export { ForwardRef as ReactComponent };